export const filterObj = <V>(
  obj:
    | {
        [key: string]: V
      }
    | {
        [key: number]: V
      },
  filterFn: (key: string, val: V) => boolean,
) =>
  Object.fromEntries(
    Object.entries(obj).filter(([key, val]) => filterFn(key, val)),
  )
